import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import Async from './Async';
import Sync from './Sync';

class Select2 extends React.Component {
  constructor(props) {
    super(props);

    this.selectInput = null;
    this.setInput = this.setInput.bind(this);
  }

  componentDidMount() {
    this.setChangeListener();
  }

  componentWillUnmount() {
    $(this.selectInput).select2('destroy');
  }

  setChangeListener() {
    const { changeListener } = this.props;

    if (changeListener) {
      $(this.selectInput).on('change', () => {
        changeListener(this.getChangeData());
      });
    }
  }

  getChangeData() {
    const changeData = {};
    changeData[this.props.friendlyNameField] = this.getText();
    return $.extend({}, $(this.selectInput).select2("data")[0], changeData);
  }

  getText() {
    const data = $(this.selectInput).select2("data")[0];
    return data ? data.text : '';
  }

  setInput(element) {
    this.selectInput = element;
  }

  render() {
    const { url, inline, style } = this.props;
    const Component = url ? Async : Sync;

    const select = (
      <div className="select2-control">
        <Component {...this.props} setInput={this.setInput}/>
      </div>
    );

    if (inline) {
      return select;
    } else {
      return (
        <div className="form-group" style={style}>
          {select}
        </div>
      );
    }
  }
}

Select2.propTypes = {
  friendlyNameField: PropTypes.string.isRequired, // I.e. id_from_network

  url: PropTypes.string,
  style: PropTypes.any,
  inline: PropTypes.bool,
  changeListener: PropTypes.func
};

Select2.defaultProps = {
  allowSearch: false,
  placeholderText: 'Select an item',
  width: '20em'
};

export default Select2;
